import store from '../store'

export default async (to, from, next) => {
  await store.dispatch('bundle/getBundles')
  await store.dispatch('item/getItems')
  await store.dispatch('ipackage/getIpackages')
  next()
}



// WEBPACK FOOTER //
// ./src/router/LoadFloorplan.js